import(/* webpackMode: "eager" */ "/app/src/app/[locale]/book-trial/page.tsx");
